import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/news/标题.png")